import { render, staticRenderFns } from "./editProjectBaseInfo.vue?vue&type=template&id=e545a4b0&scoped=true&"
import script from "./editProjectBaseInfo.vue?vue&type=script&lang=js&"
export * from "./editProjectBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./editProjectBaseInfo.vue?vue&type=style&index=0&id=e545a4b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e545a4b0",
  null
  
)

export default component.exports